export const board_games = [
  // --- 骰子 ---
  { char: '⚀', name: 'Dice 1', nameZh: '骰子一點', keywords: ['dice', 'luck', 'one'] },
  { char: '⚁', name: 'Dice 2', nameZh: '骰子二點', keywords: ['dice', 'two'] },
  { char: '⚂', name: 'Dice 3', nameZh: '骰子三點', keywords: ['dice', 'three'] },
  { char: '⚃', name: 'Dice 4', nameZh: '骰子四點', keywords: ['dice', 'four'] },
  { char: '⚄', name: 'Dice 5', nameZh: '骰子五點', keywords: ['dice', 'five'] },
  { char: '⚅', name: 'Dice 6', nameZh: '骰子六點', keywords: ['dice', 'win', 'max', 'six'], hot: true },

  // --- 西洋棋 (白) ---
  { char: '♔', name: 'White King', nameZh: '國王(白)', keywords: ['chess', 'king', 'leader'] },
  { char: '♕', name: 'White Queen', nameZh: '皇后(白)', keywords: ['chess', 'queen', 'power'] },
  { char: '♖', name: 'White Rook', nameZh: '城堡(白)', keywords: ['chess', 'rook', 'castle'] },
  { char: '♗', name: 'White Bishop', nameZh: '主教(白)', keywords: ['chess', 'bishop'] },
  { char: '♘', name: 'White Knight', nameZh: '騎士(白)', keywords: ['chess', 'knight', 'horse'] },
  { char: '♙', name: 'White Pawn', nameZh: '兵(白)', keywords: ['chess', 'pawn'] },
  // --- 西洋棋 (黑) ---
  { char: '♚', name: 'Black King', nameZh: '國王(黑)', keywords: ['chess', 'king', 'dark'] },
  { char: '♛', name: 'Black Queen', nameZh: '皇后(黑)', keywords: ['chess', 'queen', 'dark'] },
  { char: '♜', name: 'Black Rook', nameZh: '城堡(黑)', keywords: ['chess', 'rook', 'castle'] },
  { char: '♝', name: 'Black Bishop', nameZh: '主教(黑)', keywords: ['chess', 'bishop'] },
  { char: '♞', name: 'Black Knight', nameZh: '騎士(黑)', keywords: ['chess', 'knight', 'horse'] },
  { char: '♟', name: 'Black Pawn', nameZh: '兵(黑)', keywords: ['chess', 'pawn'] },

  // --- 撲克：黑桃 (Spades) ---
  { char: '♠️', name: 'Spade Suit', nameZh: '黑桃符號', keywords: ['poker', 'suit', 'black'], hot: true },
  { char: '🂡', name: 'Ace of Spades', nameZh: '黑桃A', keywords: ['card', 'ace', 'spade', 'top'] },
  { char: '🂢', name: '2 of Spades', nameZh: '黑桃2', keywords: ['card', 'spade'] },
  { char: '🂣', name: '3 of Spades', nameZh: '黑桃3', keywords: ['card', 'spade'] },
  { char: '🂤', name: '4 of Spades', nameZh: '黑桃4', keywords: ['card', 'spade'] },
  { char: '🂥', name: '5 of Spades', nameZh: '黑桃5', keywords: ['card', 'spade'] },
  { char: '🂦', name: '6 of Spades', nameZh: '黑桃6', keywords: ['card', 'spade'] },
  { char: '🂧', name: '7 of Spades', nameZh: '黑桃7', keywords: ['card', 'spade'] },
  { char: '🂨', name: '8 of Spades', nameZh: '黑桃8', keywords: ['card', 'spade'] },
  { char: '🂩', name: '9 of Spades', nameZh: '黑桃9', keywords: ['card', 'spade'] },
  { char: '🂪', name: '10 of Spades', nameZh: '黑桃10', keywords: ['card', 'spade'] },
  { char: '🂫', name: 'Jack of Spades', nameZh: '黑桃J', keywords: ['card', 'jack'] },
  { char: '🂬', name: 'Knight of Spades', nameZh: '黑桃騎士', keywords: ['card', 'knight', 'horse'] },
  { char: '🂭', name: 'Queen of Spades', nameZh: '黑桃Q', keywords: ['card', 'queen'] },
  { char: '🂮', name: 'King of Spades', nameZh: '黑桃K', keywords: ['card', 'king'] },

  // --- 撲克：紅心 (Hearts) ---
  { char: '♥️', name: 'Heart Suit', nameZh: '紅心符號', keywords: ['poker', 'suit', 'love'], hot: true },
  { char: '🂱', name: 'Ace of Hearts', nameZh: '紅心A', keywords: ['card', 'ace', 'heart'] },
  { char: '🂲', name: '2 of Hearts', nameZh: '紅心2', keywords: ['card', 'heart'] },
  { char: '🂳', name: '3 of Hearts', nameZh: '紅心3', keywords: ['card', 'heart'] },
  { char: '🂴', name: '4 of Hearts', nameZh: '紅心4', keywords: ['card', 'heart'] },
  { char: '🂵', name: '5 of Hearts', nameZh: '紅心5', keywords: ['card', 'heart'] },
  { char: '🂶', name: '6 of Hearts', nameZh: '紅心6', keywords: ['card', 'heart'] },
  { char: '🂷', name: '7 of Hearts', nameZh: '紅心7', keywords: ['card', 'heart'] },
  { char: '🂸', name: '8 of Hearts', nameZh: '紅心8', keywords: ['card', 'heart'] },
  { char: '🂹', name: '9 of Hearts', nameZh: '紅心9', keywords: ['card', 'heart'] },
  { char: '🂺', name: '10 of Hearts', nameZh: '紅心10', keywords: ['card', 'heart'] },
  { char: '🂻', name: 'Jack of Hearts', nameZh: '紅心J', keywords: ['card', 'jack'] },
  { char: '🂼', name: 'Knight of Hearts', nameZh: '紅心騎士', keywords: ['card', 'knight'] },
  { char: '🂽', name: 'Queen of Hearts', nameZh: '紅心Q', keywords: ['card', 'queen'] },
  { char: '🂾', name: 'King of Hearts', nameZh: '紅心K', keywords: ['card', 'king'] },

  // --- 撲克：梅花 (Clubs) ---
  { char: '♣️', name: 'Club Suit', nameZh: '梅花符號', keywords: ['poker', 'suit', 'luck'] },
  { char: '🃑', name: 'Ace of Clubs', nameZh: '梅花A', keywords: ['card', 'ace', 'club'] },
  { char: '🃒', name: '2 of Clubs', nameZh: '梅花2', keywords: ['card', 'club'] },
  { char: '🃓', name: '3 of Clubs', nameZh: '梅花3', keywords: ['card', 'club'] },
  { char: '🃔', name: '4 of Clubs', nameZh: '梅花4', keywords: ['card', 'club'] },
  { char: '🃕', name: '5 of Clubs', nameZh: '梅花5', keywords: ['card', 'club'] },
  { char: '🃖', name: '6 of Clubs', nameZh: '梅花6', keywords: ['card', 'club'] },
  { char: '🃗', name: '7 of Clubs', nameZh: '梅花7', keywords: ['card', 'club'] },
  { char: '🃘', name: '8 of Clubs', nameZh: '梅花8', keywords: ['card', 'club'] },
  { char: '🃙', name: '9 of Clubs', nameZh: '梅花9', keywords: ['card', 'club'] },
  { char: '🃚', name: '10 of Clubs', nameZh: '梅花10', keywords: ['card', 'club'] },
  { char: '🃛', name: 'Jack of Clubs', nameZh: '梅花J', keywords: ['card', 'jack'] },
  { char: '🃜', name: 'Knight of Clubs', nameZh: '梅花騎士', keywords: ['card', 'knight'] },
  { char: '🃝', name: 'Queen of Clubs', nameZh: '梅花Q', keywords: ['card', 'queen'] },
  { char: '🃞', name: 'King of Clubs', nameZh: '梅花K', keywords: ['card', 'king'] },

  // --- 撲克：方塊 (Diamonds) ---
  { char: '♦️', name: 'Diamond Suit', nameZh: '方塊符號', keywords: ['poker', 'suit', 'money'], hot: true },
  { char: '🃁', name: 'Ace of Diamonds', nameZh: '方塊A', keywords: ['card', 'ace', 'diamond'] },
  { char: '🃂', name: '2 of Diamonds', nameZh: '方塊2', keywords: ['card', 'diamond'] },
  { char: '🃃', name: '3 of Diamonds', nameZh: '方塊3', keywords: ['card', 'diamond'] },
  { char: '🃄', name: '4 of Diamonds', nameZh: '方塊4', keywords: ['card', 'diamond'] },
  { char: '🃅', name: '5 of Diamonds', nameZh: '方塊5', keywords: ['card', 'diamond'] },
  { char: '🃆', name: '6 of Diamonds', nameZh: '方塊6', keywords: ['card', 'diamond'] },
  { char: '🃇', name: '7 of Diamonds', nameZh: '方塊7', keywords: ['card', 'diamond'] },
  { char: '🃈', name: '8 of Diamonds', nameZh: '方塊8', keywords: ['card', 'diamond'] },
  { char: '🃉', name: '9 of Diamonds', nameZh: '方塊9', keywords: ['card', 'diamond'] },
  { char: '🃊', name: '10 of Diamonds', nameZh: '方塊10', keywords: ['card', 'diamond'] },
  { char: '🃋', name: 'Jack of Diamonds', nameZh: '方塊J', keywords: ['card', 'jack'] },
  { char: '🃌', name: 'Knight of Diamonds', nameZh: '方塊騎士', keywords: ['card', 'knight'] },
  { char: '🃍', name: 'Queen of Diamonds', nameZh: '方塊Q', keywords: ['card', 'queen'] },
  { char: '🃎', name: 'King of Diamonds', nameZh: '方塊K', keywords: ['card', 'king'] },

  // --- 王牌與其他 ---
  { char: '🃏', name: 'Joker', nameZh: '鬼牌/王牌', keywords: ['card', 'luck', 'secret', 'joker'], hot: true },
  { char: '🎰', name: 'Slot Machine', nameZh: '拉霸/幸運', keywords: ['win', 'money', 'luck'] },
  { char: '🎮', name: 'Video Game', nameZh: '電玩手把', keywords: ['play', 'fun'] },
];